type BolderizeType = 'single' | 'double'
type BolderizeOptions = {
  type?: BolderizeType
}

const BOLDERIZE_SINGLE_REGEX = /\*([^*]*)\*/g
export const BOLDERIZE_DOUBLE_REGEX = /\*\*(.*?)\*\*/g
export const BOLDERIZE_DOUBLE_REGEX_PART = /\*\*/g

/**
 * Transforms the text inside asterisks into bold text
 * @param text
 *
 * @example bolderize("*title*", {type: 'single}) => <strong>title<strong>
 * @example bolderize("**title**", {type: 'double'}) => <strong>title<strong>
 */
export const bolderize = (text: string, options: BolderizeOptions = {}) => {
  if (typeof text !== 'string') {
    return null
  }
  const bolderizeRegex =
    options.type === 'single' ? BOLDERIZE_SINGLE_REGEX : BOLDERIZE_DOUBLE_REGEX

  return text.replace(bolderizeRegex, (_, p1) => `<strong>${p1}</strong>`)
}
